"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVideoMarkerLinkAssetProperty = exports.videoMarkerLinkAssetPropertyDefinition = void 0;
exports.videoMarkerLinkAssetPropertyDefinition = {
    name: 'video-marker-link-asset',
    type: 'asset',
    multiple: false,
    view: { label: 'Asset' },
    constraints: [],
};
const isVideoMarkerLinkAssetProperty = (prop) => {
    return prop.name === exports.videoMarkerLinkAssetPropertyDefinition.name;
};
exports.isVideoMarkerLinkAssetProperty = isVideoMarkerLinkAssetProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlkZW8tbWFya2VyLWxpbmstYXNzZXQucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy92aWRlby1tYXJrZXItbGluay1hc3NldC5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHNDQUFzQyxHQUFHO0lBQ3BELElBQUksRUFBRSx5QkFBeUI7SUFDL0IsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUU7SUFDeEIsV0FBVyxFQUFFLEVBQUU7Q0FDZ0IsQ0FBQTtBQUkxQixNQUFNLDhCQUE4QixHQUFHLENBQUMsSUFBa0IsRUFBd0MsRUFBRTtJQUN6RyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssOENBQXNDLENBQUMsSUFBSSxDQUFBO0FBQ2xFLENBQUMsQ0FBQTtBQUZZLFFBQUEsOEJBQThCLGtDQUUxQyJ9